export default __webpack_public_path__ + "static/media/competition-organizers.19f80fd3.md";